module.exports = __webpack_public_path__ + "img/Audoora_Services_Logos_Order_white.c8562c2af56f2bbc5a1f4215a1876459.svg";